
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class IsometricCubesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
         const size = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, size);
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const drawCube = (x: number, y: number, s: number) => {
            const h = s * Math.sin(Math.PI / 6);
            const w = s * Math.cos(Math.PI / 6);

            // Vertical lines
            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.lineTo(x, y + s);
            ctx.moveTo(x - w, y - h);
            ctx.lineTo(x - w, y - h + s);
            ctx.moveTo(x + w, y - h);
            ctx.lineTo(x + w, y - h + s);
            ctx.stroke();

            // Rhombus top
            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.lineTo(x - w, y - h);
            ctx.lineTo(x, y - 2 * h);
            ctx.lineTo(x + w, y - h);
            ctx.closePath();
            ctx.stroke();

            // Bottom base
            ctx.beginPath();
            ctx.moveTo(x, y + s);
            ctx.lineTo(x - w, y - h + s);
            ctx.moveTo(x, y + s);
            ctx.lineTo(x + w, y - h + s);
            ctx.stroke();
        };

        const draw = () => {
            for (let x = x1; x <= x2; x += size * 1.732) {
                for (let y = y1; y <= y2; y += size * 1.5) {
                    const offset = (Math.round(y / (size * 1.5)) % 2 === 0) ? 0 : size * 0.866;
                    drawCube(x + offset, y, size * 0.6 * scale);
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
